export function generarContrato(program, pagos, estudiante, montos, inscripcion) {
  window.console.log('jajjajajaj generarrrrrr    ', window.stringifyObject(inscripcion));
  if (estudiante == null) {
    window.console.error('Estudiante no seleccionado');
    return;
  }
  //var cat = program.postgrado.categoria.nombre;
  var cuotas_canceladas = inscripcion.cuotas_canceladas;
  var pmatricula = inscripcion.matricula;
  if (!cuotas_canceladas) cuotas_canceladas = [];
  if (!pmatricula) pmatricula = {};
  var pos = program.postgrado.nombre;
  var programa = ' ' + pos;
  var nombre = estudiante.nombres + ' ' + estudiante.pri_apellido;
  var carnet = estudiante.num_doc;
  var matricula = montos.monto_matricula + '';
  var colegiatura = montos.monto_colegiatura + '';
  var monto = '' + colegiatura;
  var domicilio = estudiante.domicilio;
  if (!domicilio) domicilio = '';
  var fecha = new Date();
  var dia = fecha.getDate();
  var mes = fecha.getMonth() + 1;
  if (mes == 1) mes = 'enero';
  else if (mes == 2) mes = 'febrero';
  else if (mes == 3) mes = 'marzo';
  else if (mes == 4) mes = 'abril';
  else if (mes == 5) mes = 'mayo';
  else if (mes == 6) mes = 'junio';
  else if (mes == 7) mes = 'julio';
  else if (mes == 8) mes = 'agosto';
  else if (mes == 9) mes = 'septiembre';
  else if (mes == 10) mes = 'octubre';
  else if (mes == 11) mes = 'noviembre';
  else if (mes == 12) mes = 'diciembre';

  if (estudiante.seg_apellido) nombre += ' ' + estudiante.pri_apellido;
  nombre = nombre.toUpperCase();
  //var vue = this;
  var doc = new window.jsPDF({ orientation: 'p', unit: 'px', format: 'a4', fontSize: 1, putOnlyUsedFonts: false });

  //doc.addFont('ArialMS', 'Arial', 'normal');
  // doc.setFont('Arial');
  doc.cellInitialize();
  doc.setFontSize(10.5);
  doc.setFontStyle('bold');
  //doc.setTextColor(5, 65, 212);
  doc.text('CONTRATO POR PRESTACION DE SERVICIOS ACADEMICOS DE POSTGRADO', 220, 40, null, null, 'center');

  doc.setFontSize(10);
  doc.setFontStyle('normal');
  var ii = 55;
  var padl = 40;
  doc.text(
    'Conste por el tenor del presente documento privado, CONTRATO DE PRESTACIÓN DE SERVICIOS ACADÉMICOS',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'DE POSGRADO, mismo que a sólo reconocimiento de firmas y rúbricas ante Autoridad competente surtirá los efectos',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'de Instrumento Público, de conformidad con lo dispuesto por el Art. 519 y 1.297 del Código Civil con sujeción a las',
    padl,
    ii,
  );
  ii += 8;
  doc.text('siguientes cláusulas:', padl, ii);
  ii += 15;

  doc.setFontStyle('bold');
  doc.text('PRIMERA. - (DE LAS PARTES)', padl, ii);
  ii += 15;
  doc.setFontStyle('normal');
  doc.text('Son partes del presente documento:', padl, ii);
  ii += 15;
  doc.text(
    'I.1.- La Escuela Superior de Administración y Marketing & Negocios (ESAM), según Convenio marco de Cooperación',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'académica Interinstitucional con la UNIVERSIDAD NACIONAL SIGLO XX, con domicilio en Calle Ingavi N° 156 entre',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'Colón y Suipacha- Edificio Coronado Ofi. N° 101 de la ciudad de Tarija representada según Poder Notarial N° 362/2017',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'por CELINA PADILLA CESPEDEZ con cédula de identidad N° 5638938, expedida en Chuquisaca, vecina de ésta, de',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'nacionalidad boliviana y hábil por ley en adelante llamada “ESAM.”  El poder es otorgado por el Sr. Severino Félix',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'Cari Quispe en la notaria del Dr. Rubén Murillo Antelo, ubicada en la calle Colon entre Bolívar y Av. Domingo Paz,',
    padl,
    ii,
  );
  ii += 8;
  doc.text('edificio Monumental oficina nº10, realizada en fecha 21 de julio del 2017.', padl, ii);
  ii += 15;

  doc.setFontStyle('bold');
  doc.setFontSize(9.4);
  if (domicilio.length > 35) doc.text(domicilio, 80, ii + 8);
  else if (domicilio.length > 25) doc.text(domicilio, 110, ii + 8);
  else if (domicilio.length > 20) doc.text(domicilio, 120, ii + 8);
  else doc.text(domicilio, 140, ii + 8);
  if (nombre.length > 25) doc.text(nombre, 95, ii - 1);
  else doc.text(nombre, 110, ii - 1);
  doc.setFontSize(10);
  doc.text(carnet, 365, ii - 1);
  doc.setFontStyle('normal');
  doc.text('I.2.- El señor(a) ……………………………………………………….. de nacionalidad boliviana con C.I. ……………… con', padl, ii);
  ii += 8;
  doc.text('domicilio …………………………………………………………………..en adelante llamado “EL POSGRADUANTE”.', padl, ii);
  ii += 15;

  doc.setFontStyle('bold');
  doc.text('SEGUNDA. - (CARACTERÍSTICAS DEL DIPLOMADO).', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('- El programa tiene como propósito fundamental el', 230, ii);
  ii += 8;
  doc.text(
    'perfeccionamiento al más alto nivel práctico y teórico de todos los temas a tratar en cada uno de los módulos del',
    padl,
    ii,
  );
  ii += 8;
  //doc.text('programa DIPLOMADO EN GESTION TRIBUTARIA.', padl, ii ); ii += 20;
  doc.text('programa ' + programa, padl, ii);
  ii += 20;

  doc.text(
    'La estructura del programa está diseñada y orientada a profesionales de todas las áreas del saber humano, la',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'modalidad del desarrollo del programa formativo por la ESAM es semipresencial, entre la metodología empleada se',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'destacan las clases activas - participativas, prácticas, expositivas, apoyo audiovisual y apoyo en las TICs (si es',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'necesario), realizando de manera permanente el análisis de casos prácticos y apoyo de plataforma virtual Moodle.',
    padl,
    ii,
  );
  ii += 20;

  doc.text(
    'El programa tiene una carga horaria determinada en base a las horas presenciales, apoyo virtual, prácticas e',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'investigación destinadas a trabajos prácticos en grupo o individuales, haciendo un total de 800 horas académicas en',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'el diplomado, Reglamento del Sistema Nacional de Estudios de Posgrado de la Universidad Boliviana emitido por el',
    padl,
    ii,
  );
  ii += 8;
  doc.text('Comité Ejecutivo de la Universidad Boliviana (CEUB).', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('TERCERA. - (RESPONSABILIDADES DE LOS POSGRADUANTES)', padl, ii);
  ii += 8;
  doc.setFontStyle('normal');
  doc.text('Son responsabilidades de los POSGRADUANTES:', padl, ii);
  ii += 8;
  doc.text('a)	Mantener y guardar respeto con las autoridades, docentes y sus compañeros.', padl, ii);
  ii += 8;
  doc.text(
    'b)	Someterse a las evaluaciones de cada uno de los módulos en los plazos estipulados, bajo sus diferentes',
    padl,
    ii,
  );
  ii += 8;
  doc.text('dimensiones.', padl, ii);
  ii += 8;
  doc.text(
    'c)	Evaluar bajo diferentes criterios establecidos por la coordinación académica el desarrollo del programa.',
    padl,
    ii,
  );
  ii += 8;
  doc.text('d)	Cumplir puntualmente con la inversión del programa en las fechas y montos establecidos.', padl, ii);
  ii += 8;
  doc.text(
    'e)	En coherencia con la normativa del CEUB, es obligación del alumno asistir a todas las clases ya sean presenciales o virtuales ',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    '(80% de asistencia como mínimo) programadas en los Módulos, salvo motivo de fuerza mayor debidamente',
    padl,
    ii,
  );
  ii += 8;
  doc.text('justificado por escrito, y con los respaldos correspondientes.', padl, ii);
  ii += 8;
  doc.text(
    'f)	Entrega de documentación requerida por la Universidad Nacional Siglo XX, en plazos y formatos definidos',
    padl,
    ii,
  );
  ii += 8;
  doc.text('para el trámite de trámite de Titulo(s).', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('CUARTA. - (RESPONSABILIDADES DE LA ESAM)', padl, ii);
  ii += 8;
  doc.setFontStyle('normal');
  doc.text(
    'a)	La ESAM se compromete a viabilizar la titulación de Diplomado en gestión tributaria con la Universidad',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'Nacional SIGLO XX, de acuerdo al proyecto académico propuesto, que cumple con la estructura curricular y',
    padl,
    ii,
  );
  ii += 8;
  doc.text('la carga horaria del Comité Ejecutivo de la Universidad Boliviana (CEUB).', padl, ii);
  ii += 8;
  doc.text(
    'b)	Si por razones de fuerza mayor, algún docente no pueda desarrollar un Módulo, la ESAM se compromete a',
    padl,
    ii,
  );
  ii += 8;
  doc.text('reemplazar por otro con similar o superior formación y experiencia profesional académica.', padl, ii);
  ii += 8;
  doc.text('c)	Garantizar la idoneidad, formación académica y capacidad académica del plantel docente.', padl, ii);
  ii += 8;
  doc.text('d)	Proveer la infraestructura acorde al desarrollo del programa.', padl, ii);
  ii += 8;
  doc.text('e)	Desarrollar los módulos de acuerdo a la propuesta académica del diplomado.', padl, ii);
  ii += 20;

  doc.text('LA ESAM se compromete a concluir el PROGRAMA DE DIPLOMADO EN GESTION TRIBUTARIA hasta su', padl, ii);
  ii += 8;
  doc.text(
    'finalización de acuerdo al plan curricular ofertado y la (Titulación), debiendo cumplir con los compromisos',
    padl,
    ii,
  );
  ii += 8;
  doc.text('asumidos para tal efecto.', padl, ii);
  ii += 8;

  ii = 35;
  doc.addPage('a4', 'p');
  doc.setFontStyle('bold');
  doc.setFontSize(10);
  doc.text('QUINTA. - (DECLARACIÓN DE DEUDA). – ', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('EL POSGRADUANTE, declara ser deudor a la ESAM de la suma de Bs', 190, ii);
  ii += 8;
  doc.setFontStyle('bold');
  //doc.text('5.500,00 (CINCO MIL QUINIENTOS 00/100 bolivianos),', padl, ii ); ii += 0;
  doc.text(monto + ',00(.................................................. 00/100 bolivianos),', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('por el concepto de pago del', 225, ii);
  ii += 8;
  doc.setFontStyle('bold');
  //doc.text('PROGRAMA DE DIPLOMADO EN GESTION TRIBUTARIA', padl, ii ); ii += 20;
  doc.text('PROGRAMA DE ' + programa.toUpperCase(), padl, ii);
  ii += 20;

  var pags = pagos.length + cuotas_canceladas.length;
  doc.text(matricula, padl + 50, ii + 23);
  doc.text(colegiatura, padl + 58, ii + 30);
  doc.text(pags + '', padl + 98, ii + 62);

  doc.text('SEXTA. - (INVERSIÓN Y FORMA DE PAGO). -', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('EL POSGRADUANTE, se compromete a realizar las cancelaciones', 205, ii);
  ii += 8;
  doc.text('económicas a la ESAM por los siguientes conceptos:', padl, ii);
  ii += 15;

  doc.text('a) Matrícula Bs .......... (............................. 00/100 bolivianos) (por única vez)', padl, ii);
  ii += 8;
  doc.text('b) Colegiatura Bs ........... (............................. 00/100 bolivianos).', padl, ii);
  ii += 8;
  doc.text(
    'c) Si el pago se realizara al contado no se cancelará la matrícula y El POSGRADUANTE pagará a la ESAM la suma',
    padl,
    ii,
  );
  ii += 8;
  doc.text('de Bs ........... (Cuatro mil ochocientos 00/100 bolivianos) por el costo de la colegiatura.', padl, ii);
  ii += 8;
  doc.text('d) Los trámites de titulación de Diplomado, podrán ser cancelados al concluir el diplomado.d) ', padl, ii);
  ii += 8;
  doc.text(
    'e) El pago podrá efectuarse en ........ cuotas hasta el 15 de cada mes, pasada la fecha de pago, se cobrará una mora de',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'Bs. ..........., por cuota vencida y quedará el posgraduante automáticamente deshabilitado de la plataforma virtual',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'f) Queda claro que la inasistencia al módulo por parte del posgraduante o postergación del módulo en caso de algún',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'motivo de fuerza mayor, no exoneran al posgraduante de las obligaciones económicas pactadas en el presente',
    padl,
    ii,
  );
  ii += 8;
  doc.text('contrato.', padl, ii);
  ii += 20;

  doc.setFontSize(9.5);
  doc.text('Todos los pagos son por adelantado y en base al siguiente plan de pagos.', padl, ii);
  ii += 12;
  doc.setFontStyle('bold');

  doc.text('Matricula', 100, ii + 2);
  ii += 0;
  doc.text('Saldo', 150, ii + 2);
  ii += 0;
  doc.text('Fecha de pago', 200, ii + 2);
  ii += 8;

  doc.text('Nro. Cuota', 100, ii + 18);
  ii += 0;
  doc.text('Monto', 150, ii + 18);
  ii += 0;
  doc.text('Fechas de pago', 200, ii + 18);
  ii += 8;
  doc.setFontStyle('normal');

  var dy = 224;
  doc.rect(95, 192, 185, 12);
  //var vue = this;
  doc.text('' + pmatricula.monto, 100, dy - 12);
  doc.text('' + pmatricula.saldo, 150, dy - 12);
  doc.text(pmatricula.cancelado ? 'PAGADO' : 'DEUDA', 220, dy - 12);
  doc.rect(95, dy - 8, 185, 12); // cuadro header cuotas
  doc.rect(95, dy - 20, 185, 12); // cuadro matricula

  cuotas_canceladas.forEach(function(e) {
    dy += 12;
    doc.text('' + e.nro_cuota, 100, dy - 1);
    doc.text('' + (e.monto - e.saldo), 150, dy - 1);
    doc.text('PAGADO', 220, dy - 1);
    doc.rect(95, dy - 8, 185, 12);
  });
  pagos.forEach(function(e) {
    dy += 12;
    doc.text('' + e.nro_cuota, 100, dy - 1);
    doc.text('' + e.monto, 150, dy - 1);
    doc.text('' + parseFechaToContrato(e.fecha), 200, dy - 1);
    doc.rect(95, dy - 8, 185, 12);
  });
  doc.line(140, 192, 140, dy + 4);
  doc.line(190, 192, 190, dy + 4);

  ii = dy + 10;
  doc.setFontSize(7.5);
  doc.text('•	Costo de trámites de Titulación Diplomado, Sujeto a RESOLUCIÓN RECTORAL Universitario de la', 80, ii);
  ii += 7;
  doc.text('Universidad Nacional Siglo XX. (vigente a la fecha). ', 95, ii);
  ii += 20;

  doc.setFontSize(10);
  doc.setFontStyle('bold');
  doc.text('SÉPTIMA.- (COMPROMISO DE PAGO, RETIRO Y ABANDONO).- ', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('Por los compromisos económicos que adquirió con', 265, ii);
  ii += 8;
  doc.text(
    'la ESAM para la organización del programa, EL POSGRADUANTE se compromete a pagar el total de las cuotas pactadas.',
    padl,
    ii,
  );
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('Retiro. - ', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('EL POSGRADUANTE que por razones justificadas deba acogerse al retiro, deberá comunicar con la ', 70, ii);
  ii += 8;
  doc.text(
    'anticipación por escrito, acompañado la documentación que acredite que tiene pagados los módulos ya cursados,',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'pudiendo reincorporase en la siguiente versión del mismo programa si este se encuentre ofertado en la presente sede',
    padl,
    ii,
  );
  ii += 8;
  doc.text('u otra donde esté operando la ESAM.', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('Abandono.- ', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('Si EL POSGRADUANTE abandona los estudios en curso sin la debida justificación, la dirección', 80, ii);
  ii += 8;
  doc.text('académica procederá a la BAJA en el proceso académico sin posibilidad de reincorporación.', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('OCTAVA. -(PAGO TOTAL A LA CULMINACION DEL PROGRAMA). -', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('A la culminación del proceso, y ante el ', 285, ii);
  ii += 8;
  doc.text(
    'incumplimiento de las obligaciones financieras con la ESAM (cuotas), el POSGRADUANTE entrará automáticamente',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'en mora sin necesidad de requerimiento judicial, notarial o legal alguno, haciéndose la deuda líquida, exigible y de',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'plazo vencido por el saldo del total de la deuda, pudiendo seguirse las acciones judiciales correspondientes.',
    padl,
    ii,
  );
  ii += 20;

  ii = 35;
  doc.addPage('a4', 'p');
  doc.setFontStyle('bold');
  doc.setFontSize(10);
  doc.text('NOVENA. - (DOMICILIO REAL).', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('Las partes establecen que para efectos de su legal citación podrán ser citados en los', 155, ii);
  ii += 8;
  doc.text(
    'domicilios declarados en sus generales de ley, teniendo la obligación de informar a la ESAM mediante carta notarial',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'en caso de que se realizará cambio de domicilio, de no hacerlo serán citados en el domicilio declarado por ellos',
    padl,
    ii,
  );
  ii += 8;
  doc.text('en el presente contrato.', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('DÉCIMA. - (ACEPTACIÓN AL PROGRAMA).-', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('EL POSGRADUANTE, acepta todas y cada una de las exigencias del', 200, ii);
  ii += 8;
  doc.text(
    'curso en cuanto a materias, horarios, suspensiones de clases, retrasos y otros inconvenientes que la ESAM requiera',
    padl,
    ii,
  );
  ii += 8;
  doc.text('y exija para llevar adelante el Programa.', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('DÉCIMA PRIMERA.- (ACEPTACIÓN). ', padl, ii);
  ii += 0;
  doc.setFontStyle('normal');
  doc.text('' + dia, 115, ii + 32);
  doc.text('' + mes, 195, ii + 32);
  doc.text('Nosotros, “ESAM”, con representación Celina Padilla Cespedez por una', 175, ii);
  ii += 8;
  doc.text(
    'parte y “EL POSGRADUANTE” por otra, de forma voluntaria y sin que medie ningún vicio del consentimiento,',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'declaramos nuestra total conformidad con todas y cada una de las cláusulas precedentes, en fe de lo cual firmamos',
    padl,
    ii,
  );
  ii += 8;
  doc.text(
    'en doble ejemplar de un solo tenor y nos comprometemos a su fiel y estricto cumplimiento, el cual es firmado en la',
    padl,
    ii,
  );
  ii += 8;
  doc.text('ciudad de Tarija a los ………. días del mes de ……………… del año dos mil veinte', padl, ii);
  ii += 20;

  doc.setFontStyle('bold');
  doc.text('', padl, ii);
  ii += 70;
  doc.text('CELINA PADILLA CESPEDEZ', 90, ii);
  ii += 0;
  doc.text('……………………………', 250, ii);
  ii += 10;
  doc.text('APODERADA ESAM', 95, ii);
  ii += 0;
  doc.text('ALUMNO (A)', 270, ii);
  ii += 10;
  doc.text('C.I. 5638938 Ch.', 100, ii);
  ii += 0;
  doc.text('C.I……………… ', 265, ii);
  ii += 10;

  doc.output('dataurlnewwindow');
  doc.save('a4.pdf');
  window.console.log('fin contrato');
}

function parseFechaToContrato(fe) {
  var vs = fe.split('-');
  return vs[2] + '/' + vs[1] + '/' + vs[0];
}
